var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyRate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 101,
    viewBox: "0 0 110 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84822 57.4887C1.84375 55.7473 1.84375 52.3703 1.84375 50.5229V1.76172H8.80963H73.3333H78.4684H81.9513V5.24466V54.0058V57.4887H78.4684H8.80963H1.84822Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8052 40.1726C16.409 40.5573 16.3997 41.1904 16.7845 41.5867L23.0544 48.0433C23.4392 48.4395 24.0723 48.4487 24.4685 48.064C24.8647 47.6792 24.874 47.0461 24.4892 46.6499L18.9159 40.9107L24.6551 35.3374C25.0514 34.9527 25.0606 34.3196 24.6759 33.9234C24.2911 33.5272 23.658 33.5179 23.2618 33.9026L16.8052 40.1726ZM40.4314 42.2264C40.9836 42.2345 41.4378 41.7934 41.4459 41.2411C41.454 40.6889 41.0129 40.2347 40.4607 40.2266L40.4314 42.2264ZM17.4872 41.8899L40.4314 42.2264L40.4607 40.2266L17.5166 39.8901L17.4872 41.8899Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1375 16.032C63.5346 15.6482 63.5453 15.0151 63.1615 14.618L56.9068 8.14665C56.523 7.74954 55.8899 7.73877 55.4928 8.12259C55.0957 8.50641 55.0849 9.13948 55.4687 9.5366L61.0285 15.2889L55.2762 20.8487C54.8791 21.2325 54.8683 21.8656 55.2521 22.2627C55.6359 22.6598 56.269 22.6706 56.6661 22.2867L63.1375 16.032ZM39.5162 13.9226C38.964 13.9132 38.5087 14.3532 38.4993 14.9055C38.4899 15.4577 38.93 15.9129 39.4822 15.9223L39.5162 13.9226ZM62.4595 14.3131L39.5162 13.9226L39.4822 15.9223L62.4255 16.3128L62.4595 14.3131Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.346 21L36.1152 34.4615",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.0006,
    cy: 32.0397,
    r: 1.96153,
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4615,
    cy: 23.9615,
    r: 1.96153,
    stroke: "black",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1348,
    cy: 67.4333,
    r: 23.3647,
    transform: "rotate(45 76.1348 67.4333)",
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 2.03171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2245 75.8885C69.6294 76.4835 68.6646 76.4835 68.0695 75.8885C67.4744 75.2934 67.4744 74.3286 68.0695 73.7335L73.9764 67.8266L68.0694 61.9196C67.4743 61.3245 67.4743 60.3597 68.0694 59.7646C68.6644 59.1696 69.6292 59.1696 70.2243 59.7646L76.1314 65.6717L82.0379 59.7651C82.633 59.17 83.5978 59.17 84.1929 59.7651C84.7879 60.3602 84.7879 61.325 84.1929 61.9201L78.2863 67.8266L84.1927 73.733C84.7878 74.3281 84.7878 75.2929 84.1927 75.888C83.5976 76.4831 82.6328 76.4831 82.0378 75.888L76.1314 69.9816L70.2245 75.8885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRate);
export default __webpack_public_path__ + "static/media/emptyRate.4e385c7e2849e24aada1b169e36435c3.svg";
export { ForwardRef as ReactComponent };